<template>
    <CustomHeader>
        <h2>
            <div class="text-center fs-xl mb-4 text-purple_300">
                {{ $props.top }}
            </div>
            <div class="text-center fs-3xl fw-bold text-white">
                {{ $props.bottom }}
            </div>
        </h2>
    </CustomHeader>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'SmallHeader',
    props: {
        top: { type: String, required: true },
        bottom: { type: String, required: true },
    },
});
</script>


